module.exports = __webpack_public_path__ + "static/media/smartphone-carrefour.54d59966.png";